export default {
  assignments: null,
  assignmentUser: null,
  selectedAssignment: null,
  selectedUser: null
}
